import styled from 'styled-components';
import { Text } from 'rebass';

const FirstUpper = styled(Text)`
  &::first-letter {
    text-transform: uppercase;
  }
`;

export default FirstUpper;



// WEBPACK FOOTER //
// ./src/components/Atoms/FirstUpper/index.js